import { AnalyticsProvider } from "../../contracts/analytics/analytics";
import { LoggerContract } from "../../contracts/logger/logger";
import AnalyticsEvents from "../../core/consts/analytics-events";

const GtmAnalyticsProvider: AnalyticsProvider = (logger: LoggerContract) => ({
  track(event: AnalyticsEvents, context?: any) {
    if (window.cookiehub?.hasConsented("analytics")) {
      window.gtag?.("event", event, context);
    }
  },
  reset() {},
  setup() {
  },
  identify(identifier: any) {},
});

export default GtmAnalyticsProvider;
